import React from "react";
import { Snackbar } from "@mui/material";
import Alert from '@mui/material/Alert';

function AlertComponent(props) {
  const handleClose = (event, reason) => {
    props.handleClose();
  };

  return (
    <Snackbar open={props.alertComponent.open} autoHideDuration={4000} onClose={handleClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
      <Alert onClose={handleClose} severity={props.alertComponent.type} variant="filled" sx={{ width: '100%' }} >
        {props.alertComponent.message}
      </Alert>
    </Snackbar>
  );
}

export default AlertComponent;
